<template>
  <div>
    <!-- 头部 -->
    <HeadTab></HeadTab>
    <!-- 头部第二部分 -->
    <div class="aboutMinu">
      <div class="aboutMinu_tit">Кто мы</div>
      <div class="aboutMinu_text">Быстрые займы.kz - это бренд онлайн-микрофинансовых услуг, которыми может
        воспользоваться каждый.Услуга
        позволяет вам решить финансовые проблемы через мобильный телефон за несколько минут, не выходя из дома, без
        залога и гарантий. <span>Лицензия на осуществление микрофинансовой деятельности</span></div>
    </div>
    <!-- 中间部分 -->
    <div class="aboutCont">
      <img class="aboutCont_img" src="/static/img/about_1.png" alt="" />
      <div class="aboutCont_con">
        <div class="aboutCont_con-tit">Наше желание</div>
        <div class="aboutCont_con-text">Мы предоставляем быстрые кредиты, ориентированы на клиента, предоставляем оптимальные условия и разумные
          процентные ставки, а также используем современные технологии для упрощения процесса и обеспечения
          эффективности и удобства.</div>
        <div class="aboutCont_con-texttwo">Мы ценим доверие клиентов и стремимся строить долгосрочные отношения. Каждый клиент – не только заемщик, но
          и партнер нашего для финансового успеха.</div>
      </div>
    </div>
    <BomTab></BomTab>
  </div>
</template>

<script>
  import HeadTab from '@/components/HeadTab.vue'
  import BomTab from '@/components/BomTab.vue'
  export default {
    data() {
      return {};
    },
    components: {
      HeadTab,
      BomTab
    },
    mounted() {},
    methods: {},
  };
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .aboutMinu {
    background-image: url(/static/img/about_bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 1.09rem 1.82rem;
    margin-bottom: 1.04rem;
  }

  .aboutMinu_tit {
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 0.28rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 0.13rem;
  }

  .aboutMinu_text {
    width: 3.65rem;
    font-family: Montserrat, Montserrat;
    font-weight: 500;
    font-size: 0.1rem;
    color: #666666;
    line-height: 0.16rem;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .aboutMinu_text span {
    color: #13A6B6;
    text-decoration-line: underline;
  }

  .aboutCont {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.82rem;
    margin-bottom: 1.04rem;
  }
  .aboutCont_img{
    width: 3.11rem;
    height: 2.24rem;
  }
  .aboutCont_con-tit{
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 0.21rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 0.17rem;
  }
  .aboutCont_con-text{
    width: 2.7rem;
    font-family: Montserrat, Montserrat;
    font-weight: 500;
    font-size: 0.08rem;
    color: #666666;
    line-height: 0.13rem;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 0.1rem;
  }
  .aboutCont_con-texttwo{
    width: 2.7rem;
    font-family: Montserrat, Montserrat;
    font-weight: 500;
    font-size: 0.08rem;
    color: #666666;
    line-height: 0.13rem;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/about.vue